import { render } from "./RedEnvelope.vue?vue&type=template&id=46f3f2ca&scoped=true"
import script from "./RedEnvelope.vue?vue&type=script&lang=js"
export * from "./RedEnvelope.vue?vue&type=script&lang=js"

import "./RedEnvelope.vue?vue&type=style&index=0&id=46f3f2ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f3f2ca"]])

export default __exports__